import styled from 'styled-components'

interface PageNumberProps {
  select?: boolean
}

export const Container = styled.div``

export const PageNumber = styled.button<PageNumberProps>`
  margin: 0.5rem !important;
  padding: 0.5rem !important;
  font-weight: 700;
  color: ${(props) =>
    props.select
      ? `rgb(${props.theme.background.high})`
      : `rgb(${props.theme.grayscale[200]})`} !important;
  border: none;

  border-radius: 50%;
  background: ${(props) => (props.select ? `rgb(${props.theme.primary.base})` : 'none')} !important;

  width: 2rem;
  height: 2rem;
`

export const NavigationButtons = styled.button`
  margin: 0.2rem !important;
  padding: 0.5rem !important;
  font-weight: 700;
  color: ${({ theme }) => `rgb(${theme.grayscale[200]}) !important`};
  border: none;
  background: none;

  &:disabled {
    cursor: not-allowed;
  }
`
